import { createGlobalStyle } from 'styled-components'

interface WhileDraggingStyleProps {
  /**
   * Force a grabbing cursor across the document. The `*` selector costs a
   * full-document style invalidation when the rule mounts, which reads as a hitch
   * at drag pickup on a long list. Pass false on touch-only surfaces, where a
   * cursor rule does nothing anyway.
   */
  $grabbingCursor?: boolean
}

const WhileDraggingStyle = createGlobalStyle<WhileDraggingStyleProps>`
  html, body {
    /* We need this because '@dnd-kit/core' uses the element.scrollBy API which
       uses the browser's scrolling preference by default, which is set by the user.
       Most users pick smooth scrolling, and for this it's a problem because when
       the method is called rapidly it cancels the previous smooth scroll attempts
       producing a jerky & slow experience */
    scroll-behavior: auto !important;
  }

  ${props => props.$grabbingCursor === false ? '' : `
    * {
      cursor: grabbing !important;
    }
  `}
`

export default WhileDraggingStyle
